import React from "react";
import midimg1 from "../Slider/mid_img.jpeg";
import "./bottomFavcomp.css";

const BottomFavcomp = () => {

return (

<div>

<img src={midimg1} className="img_ara"
alt="dry pickles home made desi village"
loading="lazy"
></img>

</div>

);
};

export default BottomFavcomp;
